module.exports = __webpack_public_path__ + "static/media/disciplineDetailTitle.f3e58e52.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/disciplineDetailTitle.png
// module id = 454
// module chunks = 0